import Flex from 'legacyfrontend/components/Flex';
import LoadSpinner from 'legacyfrontend/components/spinner';
import { usePackageCard } from 'legacyfrontend/contexts/PackageCardContext';
import { useMemo, useState } from 'react';
import FlightInfoItem from './FlightInfoItem';

const FlightsInfo = () => {
  const { packageConfigurations, packageConfigurationsIsLoading, packageConfigurationsIsFetching } =
    usePackageCard();
  const [totalMoves, setTotalMoves] = useState(undefined);
  let move = 0;

  const items = useMemo(
    () =>
      !!packageConfigurationsIsLoading ||
      !!packageConfigurationsIsFetching ||
      !packageConfigurations?.flight
        ? undefined
        : packageConfigurations.flight.tripInformation
            .sort(({ order: a }, { order: b }) => a - b)
            .map((item, index) => {
              const thisMove = move;
              let nextDepartureDate;
              if (packageConfigurations.flight.tripInformation[index + 1]) {
                const diferenciaMs =
                  index + 1 === packageConfigurations.flight.tripInformation.length
                    ? 0
                    : new Date(
                        packageConfigurations.flight.tripInformation[index + 1].departureDate
                      ) - new Date(item.arrivalDate);
                const timeDiff = Math.floor(diferenciaMs / (1000 * 60 * 60));

                nextDepartureDate =
                  timeDiff > 24
                    ? undefined
                    : packageConfigurations.flight.tripInformation[index + 1].departureDate;
              }
              if (!nextDepartureDate) {
                move++;
              }
              if (index + 1 === packageConfigurations.flight.tripInformation.length) {
                setTotalMoves(thisMove);
              }
              return {
                ...item,
                thisMove,
                nextDepartureDate,
              };
            }),
    [packageConfigurations, packageConfigurationsIsLoading, packageConfigurationsIsFetching]
  );

  return !items ? (
    <LoadSpinner style={{ marginTop: 20, marginBottom: 20 }} />
  ) : (
    <Flex className='package-card__dynamic-content__wrapper__flight-list__records' vertical>
      {items.map((item) => {
        return (
          <FlightInfoItem
            key={item.id}
            {...item}
            flightCompany={
              packageConfigurations.flight.juliaToursCompany?.nombreCompaniaAerea
                ? packageConfigurations.flight.juliaToursCompany.nombreCompaniaAerea
                : undefined
            }
            totalMoves={totalMoves}
          />
        );
      })}
    </Flex>
  );
};

export default FlightsInfo;
